<template>
  <div class="tryout_box">
    <div class="tryout_">
      <img
        style="width: 100%"
        src="../../assets/img/背景图/b8f0572820dc8ead428e654ce503149b.jpg"
        alt=""
      />
      <img
        style="position: relative; top: -25px; width: 50px"
        src="../../assets/img/ChatLibrary-logo.png"
        alt=""
      />
      <h2>ChatAnswer试用申请表</h2>
      <p>
        我们热忱地邀请您加入这场激动人心的图书馆变革之旅！让我们共同见证传统图书馆与AI技术的完美融合，引领学习新时代的未来！携手共建一个开放、智能、充满无限可能的图书馆！
      </p>
      <div class="form_box">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          style="width: 95%; max-width: 500px"
        >
          <el-form-item label="01 您的姓名" prop="username">
            <el-input v-model="ruleForm.username"></el-input>
          </el-form-item>
          <el-form-item label="02 机构名称" prop="organ_name">
            <!-- <el-input v-model="ruleForm.organ_name"></el-input> -->
            <el-select
              v-model="ruleForm.organ_name"
              clearable
              filterable
              remote
              placeholder=""
              :remote-method="remoteMethod"
              :loading="loading_sel"
              style="width: 100%"
              @change="sel_org"
              @focus="clear"
              @hook:mounted="clear"
              @visible-change="clear"
              ref="headerSearchSelect"
            >
              <el-option
                v-for="item in options_org"
                :key="item.organ_code"
                :label="item.organ_name"
                :value="item.organ_name"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="03 院系/部门/科室" prop="department">
            <el-input v-model="ruleForm.department"></el-input>
          </el-form-item> -->
          <el-form-item label="03 联系手机" prop="phone">
            <el-input v-model="ruleForm.phone"></el-input>
          </el-form-item>
          <el-form-item label="04 手机验证码：" prop="code">
            <el-input v-model="ruleForm.code" autocomplete="off" placeholder="">
              <!-- <i slot="prefix" class="el-icon-user-solid el_icon"></i> -->
              <span
                slot="suffix"
                v-if="countdown > 0"
                class="el-input__icon input_code"
              >
                <span style="color: #f56c6c">{{ countdown }}</span> 秒后重新发送
              </span>
              <span
                v-else
                slot="suffix"
                @click="verify_code"
                class="el-input__icon input_code"
                >获取手机验证码</span
              >
            </el-input>
          </el-form-item>
          <el-form-item label="05 联系邮箱" prop="email">
            <el-input v-model="ruleForm.email"></el-input>
          </el-form-item>
          <el-form-item label="06 备注" prop="reason">
            <el-input v-model="ruleForm.reason"></el-input>
          </el-form-item>
          <el-form-item
            label="07 工作证件 (账号是按照所属机构进行分配，请上传工作
证件，证明您的身份)"
            prop="cardpath"
            ><template slot="label">
              <div
                style="
                  width: 100%;
                  text-align: left;
                  line-height: 20px;
                  margin: 0 0 10px 0;
                "
              >
                <span style="font-weight: 600">07 工作证件&ensp;</span>
                <br />
                <span style="font-size: 10px"
                  >(账号是按照所属机构进行分配，请上传工作证件，证明您的身份)</span
                >
              </div>
            </template>
            <el-upload
              class="upload-demo_ avatar-uploade"
              ref="upload"
              style="width: 100%"
              multiple
              :action="action_"
              :auto-upload="false"
              :show-file-list="false"
              :on-change="handlePreview"
              :http-request="customUploadMethod"
              :limit="10"
              drag
              :file-list="fileList"
              accept=".jpg, .png"
            >
              <img
                style="width: 100%"
                v-if="imageUrl"
                :src="imageUrl"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <!-- (仅支持上传 .jpg/.png 格式) -->
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="submitForm('ruleForm')"
              >提交</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { organList, sendCode } from "@/api/classify";

export default {
  data() {
    return {
      ruleForm: {
        username: "",
        organ_name: "",
        organ_code: "",
        // department: "",
        phone: "",
        email: "",
        cardpath: "",
        reason: "",
        code: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入您的姓名", trigger: "blur" },
        ],
        organ_name: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
        ],
        // department: [
        //   { required: true, message: "请输入院系/部门/科室", trigger: "blur" },
        // ],
        phone: [
          { required: true, message: "请输入联系手机", trigger: "blur" },
          {
            validator: this.validatePhoneNumber,
            trigger: "blur",
          },
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        email: [{ required: true, message: "请输入联系邮箱", trigger: "blur" }],
        // reason: [{ required: true, message: "请输入备注", trigger: "blur" }],
        // cardpath: [
        //   { required: true, message: "请上传工作证件", trigger: "blur" },
        // ],
      },
      action_: this.$root.baseURL + "/api/uploadbugimg/",
      imageUrl: "",
      fileList: [],
      countdown: 0,
      loading_sel: false,
      options_org: [],
    };
  },
  created() {
    // console.log(this.action_);
    this.getOrg("");
  },
  methods: {
    validatePhoneNumber(rule, value, callback) {
      const phonePattern = /^1[3456789]\d{9}$/;
      if (!phonePattern.test(value)) {
        callback(new Error("请输入有效的手机号码"));
      } else {
        callback();
      }
    },
    submitForm(formName) {
      console.log(this.ruleForm);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$api.pdfupload.applyforUser(this.ruleForm).then((res) => {
            console.log(res);
            if (res.data.code == 0) {
              //   this.ruleForm.cardpath = res.data.data.filepath;
              //   this.imageUrl = URL.createObjectURL(file.raw);
              this.$message({
                message: this.$t('message.apply'),
                type: "success",
              });
              this.ruleForm = {
                username: "",
                organ_name: "",
                // department: "",
                phone: "",
                email: "",
                cardpath: "",
                reason: "",
                code: "",
                organ_code: "",
              };
              this.imageUrl = "";
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    customUploadMethod() {},
    handlePreview(file, fileList) {
      console.log(file, JSON.stringify(fileList));
      let fileType = file.raw.type;

      if (fileType === "image/jpeg" || fileType === "image/png") {
        console.log(file.raw);
        var form = new FormData();
        form.append("file", file.raw);
        this.$api.pdfupload.uploadBug(form).then((res) => {
          console.log(res);
          if (res.data.code == 0) {
            this.ruleForm.cardpath = res.data.data.filepath;
            this.imageUrl = URL.createObjectURL(file.raw);
          }
        });
      } else {
        this.$message.error(this.$t('message.upload'));
      }
      return;
    },
    verify_code() {
      //   console.log("a");
      this.$refs.ruleForm.validateField("phone", (errorMsg) => {
        if (errorMsg) {
        } else {
          // 验证通过
          sendCode({ phone: this.ruleForm.phone })
            .then((res) => {
              console.log(res);
              if (res.data.code == 0) {
                this.$message({
                  message: this.$t('public.codeTips'),
                  type: "success",
                });
                this.startCountdown();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    startCountdown() {
      this.countdown = 120;
      const timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    getOrg(val) {
      this.loading_sel = true;
      organList({ search: val })
        .then((res) => {
          this.loading_sel = false;
          this.options_org = res.data.data;
          console.log(this.options_org);
          this.options_org.push({
            organ_name: "无单位（请在备注中备注单位名称）",
            organ_code: "OTHERS",
          });
          console.log(res);
        })
        .catch((err) => {
          this.loading_sel = false;
          console.log(err);
        });
    },
    sel_org(val) {
      console.log(val);
      if (val) {
        const targetObject = this.options_org.find(
          (item) => item.organ_name === val
        );
        this.ruleForm.organ_code = targetObject.organ_code;
      } else {
        this.ruleForm.organ_code = "";
      }
    },
    remoteMethod(query) {
      console.log(query);
      if (query !== "") {
        setTimeout(() => {
          this.getOrg(query);
        }, 200);
      } else {
        this.getOrg("");
      }
    },
    clear(async) {
      console.log(async);
      this.$nextTick(() => {
        if (!async) {
          // ios 手机有延迟问题

          setTimeout(() => {
            const { headerSearchSelect } = this.$refs;
            const input =
              headerSearchSelect.$el.querySelector(".el-input__inner");
            input.removeAttribute("readonly");
          }, 200);
        }
      });
    },
  },
};
</script>

<style  lang="less" scoped>
.tryout_box {
  display: flex;
  justify-content: center;
  .tryout_ {
    max-width: 800px;
  }
}
h2 {
  font-size: 18px;
  font-weight: 500;
  // line-height: 50px;
  position: relative;
  top: -15px;
  letter-spacing: 1px;
  color: rgb(0, 0, 0);
}
p {
  line-height: 23px;
  text-align: left;
  padding: 0 18px;
  letter-spacing: 0.5px;
  color: rgb(121, 121, 121);
}
.form_box {
  padding: 0 18px;
  display: flex;
  justify-content: center;
  /deep/ .el-form-item__label {
    font-weight: 600;
  }
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .el-upload-dragger {
  // height: 80px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  // height: 80px;
  // line-height: 80px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  // height: 80px;
  height: 178px;
  display: block;
}
/deep/ .el-form-item__label:before {
  display: none;
}
.input_code:hover {
  color: #409eff;
  cursor: pointer;
}
</style>